// @ts-check
/**
 * @param {import("@tanstack/react-table").Column<any>} column
 */
export function buildPinnedTableStyle(column) {
  const isPinned = column.getIsPinned()

  if (!isPinned) {
    return {}
  }

  /** @type {import("react").CSSProperties} */
  const style = {
    position: "sticky",
    zIndex: 1,
  }

  if (isPinned === "left") {
    style.left = `${column.getStart("left")}px`
  }

  if (isPinned === "right") {
    style.right = `${column.getStart("right")}px`
  }

  return style
}
